export const menuToggle = () => {
  const button = document.querySelector('[data-js="burger-menu"]');
  const dropdownMenu = document.querySelector('[data-js="dropdown-menu"]');

  if (button && dropdownMenu) {
    document.addEventListener("menu-open", () => {
      if (document.documentElement.classList.contains("search-open")) {
        document.dispatchEvent(new Event("search-close"));
      }

      if (!document.documentElement.classList.contains("menu-open")) {
        document.documentElement.classList.add("menu-open");
        dropdownMenu.classList.add("is-open");

        button.dataset.open = true;
      }
    });

    document.addEventListener("menu-close", () => {
      if (document.documentElement.classList.contains("menu-open")) {
        document.documentElement.classList.remove("menu-open");
        dropdownMenu.classList.remove("is-open");

        button.removeAttribute("data-open");
      }
    });

    // Toggle the menu using the button
    button.addEventListener("click", (e) => {
      e.preventDefault();

      if (!button.dataset.open) {
        document.dispatchEvent(new Event("menu-open"));
      } else {
        document.dispatchEvent(new Event("menu-close"));
      }
    });

    // Close the menu using the background
    dropdownMenu.addEventListener("click", (e) => {
      if (
        e.target === e.currentTarget &&
        dropdownMenu.classList.contains("is-open")
      ) {
        if (button.dataset.open) {
          document.dispatchEvent(new Event("menu-close"));
        }
      }
    });

    // Close the menu using escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        if (button.dataset.open) {
          document.dispatchEvent(new Event("menu-close"));
        }
      }
    });

    // Handle submenu toggles
    document.querySelectorAll(".submenu-toggle").forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        const parentItem = e.target.closest("li");
        if (!parentItem) return;

        const subMenu = parentItem.querySelector(".sub-menu");

        const expanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!expanded));
        parentItem.classList.toggle("open");

        if (subMenu) {
          subMenu.style.display = expanded ? "none" : "block";
        }
      });
    });
  }
};
